var TRANSLATIONS = TRANSLATIONS || {};
TRANSLATIONS.de = TRANSLATIONS.de || {};

TRANSLATIONS.de.CHARGINGINFO = {
  TITLE: 'Ladestation',
  POWER: 'Leistung',
  EQUIPMENT: 'Ausstattung',
  EQUIPMENT_BASIC: 'Technische Grundausstattung inkl.\n' +
  'Ladecontroller, Open Charge Protocol\n' +
  '(OCPP), 1.6\n\n' +
  'Stromzähler (Hutschienenzähler)\n' +
  'mit Modbus-Protokoll\n\n' +
  'Typ 2 Ladesteckdose mit Shutter\n\n' +
  'Überspannungsschutz (optional)',
  EQUIPMENT_ADV: 'Technische Grundausstattung inkl.\n' +
  'Ladecontroller, Open Charge Protocol\n' +
  '(OCPP), 1.6\n\n' +
  'Stromzähler (Hutschienenzähler)\n' +
  'mit Modbus-Protokoll\n\n' +
  'Typ 2 Ladesteckdose mit Shutter\n\n' +
  'Überspannungsschutz (optional)\n\n' +
  'RFID-Kartenleser, QR-Code\n\n' +
  'Reservierungsfunktion\n\n' +
  'Funktionaler LED-Leuchtring\n' +
  '(Ladestatus-Anzeige)\n\n',
  EQUIPMENT_PROF: 'Technische Grundausstattung inkl.\n' +
  'Ladecontroller, Open Charge Protocol\n' +
  '(OCPP), 1.6\n\n' +
  'Smart Meter (eHZ EDL 21/40)\n' +
  '\n\n' +
  'Typ 2 Ladesteckdose mit Shutter\n\n' +
  'Überspannungsschutz (optional)\n\n' +
  'RFID-Kartenleser, QR-Code\n\n' +
  'Reservierungsfunktion\n\n' +
  'Funktionaler LED-Leuchtring\n' +
  '(Ladestatus-Anzeige)\n\n' +
  'FI -Schutzschalter Typ A mit\n' +
  'normkonformer DC-Fehlerstromüber-\n' +
  'wachung + Leitungsschutz\n\n',
  EXLPANATION: 'RFID = Radio-Frequency Identification\n'+
  'QR-Code = Quick-Response Code',
  OK: 'OK'
};

TRANSLATIONS.de.CHARGINGINFO.CHARGING_BASIC = TRANSLATIONS.de.CHARGING.CHARGING_BASIC;
TRANSLATIONS.de.CHARGINGINFO.CHARGING_ADV = TRANSLATIONS.de.CHARGING.CHARGING_ADV;
TRANSLATIONS.de.CHARGINGINFO.CHARGING_PROF = TRANSLATIONS.de.CHARGING.CHARGING_PROF;
